export const GET_TRANSACTION = 'BIRTH_CERTIFICATES/get_transaction';
export const APPROVE_TRANSACTION = 'BIRTH_CERTIFICATES/approve_transaction';
export const UPDATE_TRANSACTION = 'BIRTH_CERTIFICATES/update_transaction';
export const SHOW_TRANSACTION = 'BIRTH_CERTIFICATES/show_transaction';
export const START_ASSESSMENT = 'BIRTH_CERTIFICATES/start_assessment';
export const GET_SETTINGS = 'BIRTH_CERTIFICATES/get_settings';
export const UPDATE_TEST_STATUS = 'BIRTH_CERTIFICATES/update_health_status';
export const GET_BIRTH_ARCHIVE =
  'BIRTH_CERTIFICATES/get_birth_certificates_arhive';
export const GET_PHOTO = 'BIRTH_CERTIFICATES/getPhoto';
export const ASSESS_RECEIPT = 'BIRTH_CERTIFICATES/assess_receipt';
export const EDIT_BIRTH = 'BIRTH_CERTIFICATE/edit_birth';

export const DEPENDENCIES = {
  health_certificate_amount: {
    label: 'Health Certificate',
  },
  occupational_permit_amount: {
    label: 'Occupational Permit',
  },
  card_type: {
    label: 'CARD TYPE',
  },
  stool_amount: {
    label: 'Stool',
  },
  sputum_amount: {
    label: 'Sputum',
  },
  drug_test_amount: {
    label: 'Drug Test',
  },
  rpr_syphilis_amount: {
    label: 'RPR Syphilis',
  },
  gram_stain: {
    label: 'Gram Stain',
  },
};

export const FORM_DATA = {
  status: 'REJECT',
  remarks: '',
  first_name: '',
  last_name: '',
  middle_name: '',
  mothers_first_name: '',
  mothers_middle_name: '',
  mothers_last_name: '',
  birth_date: '',
  extension_name: '',
  registry_number: '',
  search_by: '',
};

export const EXTENSION_NAMES = [
  { label: 'N/A', value: '' },
  { label: 'JR.', value: 'JR.' },
  { label: 'SR.', value: 'SR.' },
  { label: 'II', value: 'II' },
  { label: 'III', value: 'III' },
  { label: 'IV', value: 'IV' },
  { label: 'V', value: 'V' },
  { label: 'VI', value: 'VI' },
  { label: 'VII', value: 'VII' },
  { label: 'VIII', value: 'VIII' },
  { label: 'IX', value: 'IX' },
  { label: 'X', value: 'X' },
];
